import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const InvoiceExceptionPage = lazy(() => import("@/features/dashboard/pages/invoice-exception"));

export const Route = createFileRoute("/(app)/dashboard/invoice-exception/$documentId")({
  component: () => (
    <Suspense fallback={<div className="text-muted-foreground text-sm">Loading document…</div>}>
      <InvoiceExceptionPage />
    </Suspense>
  ),
});
